import { isWithinLast30Days } from '@atlassian/jira-onboarding-core/src/utils/is-within-last-30-days/index.tsx';
import { useFirstActivationDateMs } from '@atlassian/jira-tenant-context-controller/src/components/first-activation-date-ms/index.tsx';

export const useIsFirstActivationDateWithinLast30Days = () => {
	const firstActivationDate = useFirstActivationDateMs();
	return isWithinLast30Days(firstActivationDate);
};
